/**
 * What an operator reads for the code an SES bounce is recorded under: SES's
 * bounce subtype when it says more than `General`, else the bounce's enhanced
 * status. A code absent here is shown bare.
 */
export const EMAIL_BOUNCE_CODE_LABELS: Readonly<Partial<Record<string, string>>> = {
  NoEmail: 'Address does not exist',
  Suppressed: 'On the SES global suppression list',
  OnAccountSuppressionList: 'On our SES account suppression list',
  MailboxFull: 'Mailbox full',
  MessageTooLarge: 'Message too large',
  ContentRejected: 'Content rejected',
  AttachmentRejected: 'Attachment rejected',
  General: 'Bounced with no reason given',
  Undetermined: 'Bounce reason undetermined',
  '5.1.1': 'Mailbox does not exist',
  '5.1.2': 'Domain does not exist',
  '5.1.3': 'Malformed address',
  '5.1.4': 'Ambiguous address',
  '5.1.6': 'Mailbox has moved',
  '5.1.7': "Rejected our sender's address",
  '5.1.8': "Rejected our sender's domain",
  '5.1.10': 'Domain accepts no mail',
  '5.2.1': 'Mailbox disabled',
  '5.2.2': 'Mailbox full',
  '5.7.1': "Rejected by the receiving server's policy",
};

/** What an operator reads for an SES bounce code, or `null` for one {@link EMAIL_BOUNCE_CODE_LABELS} does not name. */
export function describeEmailBounceCode(code: string): string | null {
  // Own keys only: a code such as `toString` would otherwise read `Object.prototype`.
  return Object.hasOwn(EMAIL_BOUNCE_CODE_LABELS, code) ? (EMAIL_BOUNCE_CODE_LABELS[code] ?? null) : null;
}
